import React from "react";
import { useQuery } from "@tanstack/react-query";
import Layout, { Breadcrumbs } from "../components/Layout";
import Seo from "../components/Seo";
import { getLatestCommonNumber } from "../lib/api";
import { todayDDMMYYYY } from "../lib/date";

const crumbs = [
  { name: "Home", path: "/" },
  { name: "Common Number", path: "/common-number/" },
];

function NumberTable({ game, rows }) {
  return (
    <div className="overflow-hidden rounded-md border-2 border-[#10161f] bg-white shadow-sm">
      <div className="border-b-2 border-[#10161f] bg-[#eceef0] py-2 text-center text-xl font-bold text-[#10161f] sm:text-2xl">
        {game}
      </div>
      {rows.map((row, i) => (
        <React.Fragment key={i}>
          <div className="grid grid-cols-3 border-b-2 border-[#10161f] bg-[#4fd0be]">
            <div className="border-r-2 border-[#10161f] py-1.5 text-center text-base font-semibold text-[#10161f] sm:text-lg">
              Direct
            </div>
            <div className="border-r-2 border-[#10161f] py-1.5 text-center text-base font-semibold text-[#10161f] sm:text-lg">
              House
            </div>
            <div className="py-1.5 text-center text-base font-semibold text-[#10161f] sm:text-lg">
              Ending
            </div>
          </div>
          <div
            className={`grid grid-cols-3 ${
              i < rows.length - 1 ? "border-b-2 border-[#10161f]" : ""
            }`}
          >
            <div className="border-r-2 border-[#10161f] py-2 text-center text-xl font-bold text-[#10161f] sm:text-2xl">
              {row.direct || "-"}
            </div>
            <div className="border-r-2 border-[#10161f] py-2 text-center text-xl font-bold text-[#10161f] sm:text-2xl">
              {row.house || "-"}
            </div>
            <div className="py-2 text-center text-xl font-bold text-[#10161f] sm:text-2xl">
              {row.ending || "-"}
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default function CommonNumber() {
  const displayDate = todayDDMMYYYY("/");
  const { data } = useQuery({
    queryKey: ["common-number"],
    queryFn: getLatestCommonNumber,
  });

  const cn = data?.available ? data.data : null;

  return (
    <Layout>
      <Seo
        title="Bhutan Morning Teer Common Number – Latest Update"
        description="Bhutan Morning Teer Common Number latest update with Direct, House and Ending numbers. Data is updated by our team and shown only when available."
        path="/common-number/"
        breadcrumb={crumbs}
      />
      <Breadcrumbs items={crumbs} />

      <div className="mx-auto max-w-xl px-4 py-4">
        <h1 className="sr-only">Bhutan Morning Teer Common Number</h1>

        <p
          data-testid="common-number-date"
          className="mb-3 text-center text-2xl font-extrabold text-[#10161f]"
        >
          {cn?.date || displayDate}
        </p>

        {cn ? (
          <div data-testid="common-number-table">
            <NumberTable game={cn.game} rows={cn.rows} />
          </div>
        ) : (
          <div
            data-testid="common-number-empty"
            className="rounded-md border-2 border-[#10161f] bg-white p-6 text-center text-sm text-slate-500"
          >
            Common Number for {displayDate} is not available yet. Verified data
            will be updated here.
          </div>
        )}

        <section className="mt-6 text-sm leading-relaxed text-slate-600">
          <h2 className="mb-2 text-base font-bold text-[#10161f]">
            About Common Number
          </h2>
          <p>
            The Bhutan Morning Teer Common Number is compiled from previous
            results and is shared for informational purposes only. It shows
            Direct, House and Ending numbers when verified data is available.
          </p>
        </section>
      </div>
    </Layout>
  );
}
